import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-green px-5 py-24 sm:py-32" data-id="element-115" data-mp="1o2vfqkp72f4g">
      <Reveal className="mx-auto w-full max-w-[720px]" data-id="element-116" data-mp="22368jta2e3s9">
        <div className="rounded-card bg-white px-7 py-14 text-center shadow-lift sm:px-14" data-id="element-117" data-mp="222n156i1ixsh">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-tint" data-id="element-118" data-mp="1x4v2ltmw4dfb">
            <ShieldCheckIcon className="h-8 w-8 text-green" aria-hidden="true" data-id="element-119" data-mp="19f0qjeaeasw4" />
          </span>

          <h2 className="mt-8 font-display text-4xl font-bold uppercase leading-[1] tracking-tight text-navy sm:text-5xl" data-id="element-120" data-mp="14hh965iehzzy">
            Få pengene tilbage — eller behold det hele
          </h2>

          <p className="mx-auto mt-7 max-w-[560px] text-base leading-relaxed text-ink sm:text-[17px]" data-id="element-121" data-mp="1eciyb1cof22j">
            Prøv Håndboldklar i 30 dage. Print det ud, tag det med i hallen, og brug det
            til fire træninger. Synes du ikke, det gør din forberedelse lettere, skriver
            du én mail, og du får hele beløbet tilbage. Du beholder filerne.
          </p>

          <p className="mt-6 text-sm text-muted" data-id="element-122" data-mp="txkwjagwbk39">
            Ingen begrundelse, ingen formular, intet at sende retur.
          </p>
        </div>
      </Reveal>
    </section>;
}